export default __webpack_public_path__ + "static/mobile-home-a7d06200425db230aa6574d394fa2791.png";